export default "#define GLSLIFY 1\n#include <begin_vertex>\n\ntransformed = (transformMatrix * vec4(transformed, 1.)).xyz;";